import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetAreaRecoveryReportApi } from "./Report.action";
import { Link } from "react-router-dom";
import { CalendarIcon, DownloadIcon, ChevronRightIcon } from "../../../components/Icons";
import { GetAreaApi } from "../AddArea/areaAction";
import { showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import SinglePageDashboard from "../../../drawer/SinglePageDashbord";
import GlobalFormCard from "../../../components/GlobalFormCard";
import SelectorField from "../../../components/SelectorField";
import "./Report.css";


const AreaRecoveryReport = (props) => {
    const [areaId, setAreaId] = useState("");
    const [areaName, setAreaName] = useState("");
    const isDisabled = _.isEmpty(areaId) || props.isFetchingAreaRecoveryReport || props.isFetchingAreaData;

    const GenratePDF = () => {
        const payload = {
            areaId,
            areaName,
        };
        props.GetAreaRecoveryReportApi(payload, showErrorAlert);
    };

    const handleChangeArea = (selectedOption) => {
        if (!selectedOption) {
            setAreaId("");
            setAreaName("");
            return;
        }
        setAreaId(selectedOption.value);
        setAreaName(selectedOption.label);
    };
    const AreaList = _.isEmpty(props.areaDataList) ? [] : props.areaDataList.map((x) => {
        let data = { value: x._id, label: x.areaName };
        return data;
    });

    useEffect(() => {
        props.GetAreaApi();
    }, []);

    return (
        <>
            <SinglePageDashboard header="Area Recovery Report" />

            <div className="page-container">
                <div className="breadcrumb">
                    <Link to="/home" className="breadcrumb-link">Home</Link>
                    <ChevronRightIcon />
                    <Link to="/report" className="breadcrumb-link">Reports</Link>
                    <ChevronRightIcon />
                    <span className="breadcrumb-current">Area Recovery Report</span>
                </div>

                <div className="page-header">
                    <h1 className="page-title">Area Recovery Report</h1>
                </div>

                <GlobalFormCard
                    title="Select Area"
                    subtitle="Report will be generated for this area"
                    icon={<CalendarIcon />}
                    maxWidth="900px"
                >
                    <SelectorField
                        options={AreaList}
                        value={areaId}
                        onChange={handleChangeArea}
                        isDisabled={false}
                        isLoading={props.isFetchingAreaData}
                        label="Select Area"
                    />

                    <div className="divider" />

                    <button
                        onClick={GenratePDF}
                        disabled={isDisabled}
                        className={`generate-btn ${isDisabled ? "disabled" : ""}`}
                    >
                        {props.isFetchingAreaRecoveryReport ? (
                            <>
                                <span className="spinner" />
                                Generating…
                            </>
                        ) : (
                            <>
                                <DownloadIcon />
                                Generate Report
                            </>
                        )}
                    </button>

                    <p className="footer-text">
                        Report will be downloaded as a PDF file
                    </p>

                </GlobalFormCard>
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    GetAreaRecoveryReportApi: (payload, showErrorAlert) => dispatch(GetAreaRecoveryReportApi(payload, showErrorAlert)),
    GetAreaApi: () => dispatch(GetAreaApi()),
});

const mapStateToProps = (state) => ({
    isFetchingAreaRecoveryReport: state.ReportReducer.isFetchingAreaRecoveryReport,
    areaRecoveryReportData: state.ReportReducer.areaRecoveryReportData,
    isFetchingAreaData: state.AreaReducer.isFetchingAreaData,
    areaDataList: state.AreaReducer.areaDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AreaRecoveryReport);